module.exports = __webpack_public_path__ + "static/img/add-beneficiary-graphic.c5a87e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-beneficiary-graphic.svg
// module id = 0t0N
// module chunks = 1